import { useSyncExternalStore } from 'react';

/**
 * A faixa de largura da janela, pelos pontos de quebra da R01 (p.28):
 * 1600 / 1280 / 1024 / 768.
 *
 * Existe para o que a folha de estilo NAO resolve sozinha: desenhar OUTRA
 * estrutura (a tabela vira lista de cartoes abaixo de 768), ou dizer ao leitor
 * de tela que o painel virou janela (abaixo de 1280, gaveta com `aria-modal`).
 * Tamanho, margem e visibilidade continuam no CSS, com `max-[...]`.
 *
 * A consulta e a mesma que o Tailwind escreve para `max-[1280px]:`
 * (`width < 1280px`), para o JavaScript e o CSS mudarem no mesmo pixel.
 */
export function useAbaixoDe(px: number): boolean {
  const consulta = `(width < ${String(px)}px)`;
  return useSyncExternalStore(
    (avisar) => {
      const lista = window.matchMedia(consulta);
      lista.addEventListener('change', avisar);
      return () => {
        lista.removeEventListener('change', avisar);
      };
    },
    () => window.matchMedia(consulta).matches,
    () => false,
  );
}

/** Entre dois pontos de quebra: `de` incluido, `ate` excluido. */
export function useEntre(de: number, ate: number): boolean {
  /* Os dois ganchos sempre, e so depois a conta: `&&` pularia o segundo. */
  const abaixoDoInicio = useAbaixoDe(de);
  const abaixoDoFim = useAbaixoDe(ate);
  return !abaixoDoInicio && abaixoDoFim;
}
